import React from 'react'
import { connect } from 'react-redux'
import { parse } from 'query-string'
import * as actionCreators from '../redux/action_creators'
import * as jwtUtils from '../util/jwt_utils'
import { parseVerificationCode } from '../util/onboarding_utils'

class VerifyEmail extends React.Component {
    constructor(props) {
        super(props)
        const query = parse(props.location.search)
        this.state = { token: query.t, code: query.code }
    }

    componentDidMount() {
        const { token, code } = this.state
        const { history, verifyEmail } = this.props
        jwtUtils.setToken(token)
        verifyEmail(parseVerificationCode(code), history)
    }

    render() {
        return (
            <div className="container">
                <div className="row" style={{paddingTop: 100}}>
                    <div className="col-md-4 col-md-offset-4 col-xs-12 well center">
                        <h2>Verifying email...</h2>
                    </div>
                </div>

            </div>
        )
    }
}

function mapStateToProps(state) {
    return state
}
export default connect(
    mapStateToProps, actionCreators
)(VerifyEmail)



// WEBPACK FOOTER //
// ./src/pages/verify_email.jsx